import { render } from "./Imagination.vue?vue&type=template&id=3c5808a7&scoped=true"
import script from "./Imagination.vue?vue&type=script&lang=js"
export * from "./Imagination.vue?vue&type=script&lang=js"

import "./Imagination.vue?vue&type=style&index=0&id=3c5808a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5808a7"]])

export default __exports__